/**
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const PlanSearchState = Record({
  search_keywords: '',
  search_hotel_ids: []
})

export { PlanSearchState }
